import { render, staticRenderFns } from "./FrenteDeCaixa.vue?vue&type=template&id=523bfede&scoped=true&"
import script from "./FrenteDeCaixa.vue?vue&type=script&lang=js&"
export * from "./FrenteDeCaixa.vue?vue&type=script&lang=js&"
import style0 from "./FrenteDeCaixa.vue?vue&type=style&index=0&id=523bfede&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523bfede",
  null
  
)

export default component.exports